export default __webpack_public_path__ + "static/media/fya-logo.f8781ea8.svg";